export default {

    data(){
        return {


        }
    },

    computed:{
    },

    directives: {
        
    },
    methods: {
        getJsonKeys( json ){
            
            let keys = [];
            for (const key in json) {
                keys.push(key);
            }

            return keys;
        }

    }
}